/*
 * Kunstmühle Hofmeir – Paket-Anzeige, „Passt noch rein“, „Wieder das Gleiche?“, Öffnungsstatus, Mehlstaub.
 * Daten kommen aus snippets/km-shop-data.liquid (Theme-Einstellungen → Kunstmühle).
 */
(function () {
  const readData = () => {
    const el = document.getElementById('km-shop-data');
    if (!el) return null;
    try {
      const data = JSON.parse(el.textContent);
      data.tiers = (data.tiers || [])
        .map((t) => ({ max: Math.round(Number(t.max)), price: parseFloat(t.price), label: t.label || '' }))
        .filter((t) => t.max > 0 && !Number.isNaN(t.price))
        .sort((a, b) => a.max - b.max);
      return data;
    } catch (e) {
      return null;
    }
  };

  const DATA = readData();

  const fmtKg = (grams) => {
    const kg = grams / 1000;
    const digits = kg < 10 && Math.round(kg * 100) % 10 !== 0 ? 2 : 1;
    return kg.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: digits }) + ' kg';
  };
  const fmtEur = (n) => n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  const tierFor = (grams) => {
    if (!DATA) return null;
    for (let i = 0; i < DATA.tiers.length; i++) {
      if (grams <= DATA.tiers[i].max) return { tier: DATA.tiers[i], index: i };
    }
    return null;
  };

  // Gewicht des leeren Versandkartons: Shopify rechnet es im Checkout zum Warenkorb dazu
  const packageGrams = () => (DATA && DATA.packageWeight > 0 ? DATA.packageWeight : 0);
  const shipGrams = (goods) => (goods > 0 ? goods + packageGrams() : 0);

  const priceText = (tier) => fmtEur(tier.price) + (tier.label ? ` (${tier.label})` : '');

  const fetchCartWeight = () =>
    fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => cart.total_weight || 0);

  class KmPackageMeter extends HTMLElement {
    connectedCallback() {
      if (!DATA || !DATA.tiersEnabled || !DATA.tiers.length) {
        this.hidden = true;
        return;
      }
      this.weight = parseInt(this.dataset.weight || '0', 10) || 0;
      this.variantWeight = parseInt(this.dataset.variantWeight || '0', 10) || 0;
      this.variantWeights = {};
      (this.dataset.variantWeights || '').split(',').forEach((pair) => {
        const [id, grams] = pair.split(':');
        if (id) this.variantWeights[id] = parseInt(grams, 10) || 0;
      });
      this.render();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        if (this.dataset.context === 'product') {
          this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
          const setVariant = (id) => {
            if (id && this.variantWeights[id] !== undefined && this.variantWeights[id] !== this.variantWeight) {
              this.variantWeight = this.variantWeights[id];
              this.render();
            }
          };
          this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            setVariant(event?.data?.variantId || event?.data?.variant?.id);
          });
          // Die Varianten-Tasten ändern nur das versteckte Feld „id“ (ohne variantChange-Ereignis)
          this.onIdChange = (event) => {
            const input = event.target;
            if (input && input.name === 'id' && input.classList.contains('product-variant-id') && !input.closest('quick-add-modal')) {
              setVariant(input.value);
            }
          };
          document.addEventListener('change', this.onIdChange);
        }
      }
    }

    disconnectedCallback() {
      this.unsubCart && this.unsubCart();
      this.onIdChange && document.removeEventListener('change', this.onIdChange);
      this.unsubVariant && this.unsubVariant();
    }

    refresh() {
      fetchCartWeight()
        .then((grams) => {
          this.weight = grams;
          this.render();
        })
        .catch(() => {});
    }

    render() {
      const tiers = DATA.tiers;
      const grams = shipGrams(this.weight);
      const pkgText = packageGrams() > 0 ? ` (inkl. ${fmtKg(packageGrams())} Verpackung)` : '';
      const found = tierFor(grams);
      const baseTiers = tiers.filter((t) => !t.label);
      const scaleMax = grams <= (baseTiers.length ? baseTiers[baseTiers.length - 1].max : tiers[0].max)
        ? (baseTiers.length ? baseTiers[baseTiers.length - 1].max : tiers[0].max)
        : tiers[tiers.length - 1].max;
      const visible = tiers.filter((t) => t.max <= scaleMax);
      const remaining = found ? found.tier.max - grams : 0;
      this.dataset.remaining = String(Math.max(0, remaining));

      let segments = '';
      let prev = 0;
      visible.forEach((t) => {
        const width = ((t.max - prev) / scaleMax) * 100;
        const active = found && found.tier === t ? ' is-active' : '';
        segments += `<span class="km-meter__segment${active}" style="width:${width}%"><span class="km-meter__price">${fmtEur(t.price)}</span></span>`;
        prev = t.max;
      });
      const fill = Math.min(100, (grams / scaleMax) * 100);

      let message;
      if (!found) {
        // Über der höchsten Paketstufe: Lieferung per Spedition auf Anfrage
        const last = tiers[tiers.length - 1];
        const contact = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}pages/contact`;
        // öffnet das Kontaktformular im Overlay (snippets/km-contact-dialog.liquid) mit Betreff und Gewicht
        message = `<strong>${fmtKg(grams)}</strong> – das ist mehr, als per Paket geht (bis ${fmtKg(last.max)}). Größere Mengen liefern wir per Spedition: <a href="${contact}" data-km-contact-open data-topic="Speditionsangebot" data-ref="Warenkorb: ${fmtKg(grams)}" data-title="Angebot für Speditionsversand" data-lead="Ihre Bestellung ist zu schwer für den Paketversand. Wir holen ein Speditionsangebot ein und melden uns mit dem Preis." data-placeholder="Lieferadresse (PLZ, Ort) und gewünschter Liefertermin">Angebot anfragen</a>.`;
      } else if (grams <= 0) {
        // Produktseite: bei leerem Paket keine Zeile – die Packungs-Zeile darunter sagt genug
        message = this.dataset.context === 'product'
          ? ''
          : `Ihr Paket ist noch leer. Bis ${fmtKg(found.tier.max)} kostet der Versand <strong>${priceText(found.tier)}</strong>.`;
      } else if (remaining < 100) {
        message = `<strong>Perfekt gepackt!</strong> ${fmtKg(grams)} im Paket${pkgText}, Versand ${priceText(found.tier)}.`;
      } else {
        message = `<strong>${fmtKg(grams)}</strong> im Paket${pkgText} · Versand <strong>${priceText(found.tier)}</strong>. Bis ${fmtKg(found.tier.max)} passen noch <strong>${fmtKg(remaining)}</strong> zum gleichen Preis.`;
      }

      let hint = '';
      if (this.dataset.context === 'product' && this.variantWeight > 0 && found) {
        const after = shipGrams(this.weight + this.variantWeight);
        const next = tierFor(after);
        if (next && next.tier === found.tier) {
          hint = `Diese Packung (${fmtKg(this.variantWeight)}) passt noch hinein, der Versand bleibt bei ${fmtEur(found.tier.price)}.`;
        }
      }

      const perfect = found && grams > 0 && remaining < 100;
      this.classList.toggle('is-perfect', !!perfect);
      this.innerHTML = `
        <div class="km-meter__head">
          <span class="km-meter__title">${this.dataset.title || 'Ihr Paket'}</span>
          <span class="km-meter__weight">${fmtKg(grams)}</span>
        </div>
        <div class="km-meter__bar" role="progressbar" aria-label="Paketgewicht" aria-valuemin="0" aria-valuemax="${scaleMax}" aria-valuenow="${Math.min(grams, scaleMax)}" aria-valuetext="${fmtKg(grams)} von ${fmtKg(scaleMax)}">
          <span class="km-meter__fill" style="width:${fill}%"></span>
          ${segments}
        </div>
        ${message ? `<p class="km-meter__text" aria-live="polite">${message}</p>` : ''}
        ${hint ? `<p class="km-meter__hint">${hint}</p>` : ''}
        ${DATA.tiersNote && this.dataset.context === 'product' ? `<p class="km-meter__note">${DATA.tiersNote}</p>` : ''}
      `;
      this.dispatchEvent(new CustomEvent('km:meter', { bubbles: true, detail: { remaining: Math.max(0, remaining), grams } }));
    }
  }
  if (!customElements.get('km-package-meter')) customElements.define('km-package-meter', KmPackageMeter);

  class KmFillSuggestions extends HTMLElement {
    connectedCallback() {
      if (!this.kmBound) {
        this.kmBound = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-km-fill-add]');
          if (button) this.add(button);
        });
      }
      // Inhalt erst einsetzen, wenn der Drawer offen ist (spart ~120 Elemente beim Seitenaufbau)
      const tpl = this.querySelector('template[data-km-fill-tpl]');
      if (!tpl) return this.setup();
      const drawer = this.closest('cart-drawer');
      const mount = () => {
        if (tpl.parentNode) this.replaceChild(tpl.content.cloneNode(true), tpl);
        this.setup();
      };
      if (!drawer || drawer.classList.contains('active')) return mount();
      const mo = new MutationObserver(() => {
        if (drawer.classList.contains('active')) {
          mo.disconnect();
          mount();
        }
      });
      mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    setup() {
      const meter = document.querySelector('cart-drawer km-package-meter') || document.querySelector('km-package-meter');
      const remaining = meter ? parseInt(meter.dataset.remaining || '0', 10) : 0;
      const inCart = (this.dataset.inCart || '').split(',').filter(Boolean);
      const empty = this.dataset.empty === 'true';
      const items = Array.from(this.querySelectorAll('[data-km-fill-item]'));
      const seen = new Set();
      let picks;
      if (empty) {
        picks = items.filter((el) => {
          if (seen.has(el.dataset.productId)) return false;
          seen.add(el.dataset.productId);
          return true;
        });
      } else {
        picks = items
          .filter((el) => {
            const w = parseInt(el.dataset.weight, 10) || 0;
            return w > 0 && w <= remaining && !inCart.includes(el.dataset.productId);
          })
          .sort((a, b) => parseInt(b.dataset.weight, 10) - parseInt(a.dataset.weight, 10))
          .filter((el) => {
            if (seen.has(el.dataset.productId)) return false;
            seen.add(el.dataset.productId);
            return true;
          });
      }
      // Passt nichts mehr ins Paket: allgemeine Vorschläge (nicht im Warenkorb, je Produkt eine Variante)
      const fallback = !empty && picks.length === 0;
      if (fallback) {
        seen.clear();
        picks = items.filter((el) => {
          if (inCart.includes(el.dataset.productId) || seen.has(el.dataset.productId)) return false;
          seen.add(el.dataset.productId);
          return true;
        });
      }
      picks = picks.slice(0, 3);
      items.forEach((el) => (el.hidden = !picks.includes(el)));
      this.hidden = picks.length === 0;
      if (!this.hidden && !empty) {
        const title = this.querySelector('[data-km-fill-title]');
        if (title) title.textContent = fallback ? 'Das passt dazu' : `Passt noch rein – ${fmtKg(remaining)} Platz`;
      }
    }

    add(button) {
      const item = button.closest('[data-km-fill-item]');
      const drawer = document.querySelector('cart-drawer');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(item.dataset.variantId), quantity: 1 }],
          sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) throw new Error(response.description);
          if (drawer) drawer.renderContents(response);
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'km-fill' });
          window.kmDust && window.kmDust();
        })
        .catch(() => {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          button.textContent = 'Nicht verfügbar';
        });
    }
  }
  if (!customElements.get('km-fill-suggestions')) customElements.define('km-fill-suggestions', KmFillSuggestions);

  // „Wieder das Gleiche?“: Der Browser merkt sich den Warenkorb („current“). Ist er beim nächsten
  // Seitenaufruf leer, war das meist eine Bestellung – dann wird er zum letzten Einkauf („last“).
  // Leert jemand den Warenkorb selbst, wird nichts übernommen.
  const REORDER_KEYS = { current: 'km-cart-current', last: 'km-cart-last', hidden: 'km-reorder-hidden' };
  const store = {
    get(key) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch (e) {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    },
    remove(key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {}
    },
  };
  const reorderItems = (items) =>
    (Array.isArray(items) ? items : []).filter((i) => i && Number(i.id) > 0 && Number(i.q) > 0).slice(0, 30);
  const sizedImage = (src) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', '120');
      return url.toString();
    } catch (e) {
      return '';
    }
  };
  const fromCartJs = (cart) =>
    (cart.items || [])
      .filter((i) => !i.gift_card)
      .map((i) => ({
        id: i.variant_id,
        q: i.quantity,
        t: i.product_title,
        v: i.product_has_only_default_variant ? '' : i.variant_title || '',
        img: sizedImage(i.image),
        url: i.url,
      }));
  const rememberCart = (items) => {
    const list = reorderItems(items);
    if (list.length) store.set(REORDER_KEYS.current, { ts: Date.now(), items: list });
    else store.remove(REORDER_KEYS.current);
  };

  if (DATA && Array.isArray(DATA.cart)) {
    if (reorderItems(DATA.cart).length) {
      rememberCart(DATA.cart);
    } else {
      const current = store.get(REORDER_KEYS.current);
      if (current && reorderItems(current.items).length) store.set(REORDER_KEYS.last, current);
      store.remove(REORDER_KEYS.current);
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    let cartTimer;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(() => {
        fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin' })
          .then((r) => r.json())
          .then((cart) => rememberCart(fromCartJs(cart)))
          .catch(() => {});
      }, 300);
    });
  }

  // Mehrere Artikel auf einmal in den Warenkorb ({ id, q, t, v }). Scheitert das (z. B. ein Mehl
  // ausverkauft), wird einzeln nachgelegt. Danach öffnet sich der Drawer, sonst geht es zum Warenkorb.
  // Auch für die Schnellbestellung (assets/km-quick-order.js).
  const kmAddItems = async (items, { source = 'km', drawer: useDrawer = true } = {}) => {
    const drawer = useDrawer ? document.querySelector('cart-drawer') : null;
    const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
    const post = (list, withSections) =>
      fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: list.map((i) => ({ id: Number(i.id), quantity: Number(i.q) })),
          ...(withSections && sections.length ? { sections, sections_url: window.location.pathname } : {}),
        }),
      }).then((r) =>
        r.json().then((json) => {
          if (!r.ok || json.status) throw new Error(json.description || 'add failed');
          return json;
        })
      );

    const failed = [];
    let response = null;
    try {
      response = await post(items, true);
    } catch (e) {
      for (const item of items) {
        try {
          await post([item], false);
        } catch (err) {
          failed.push(item);
        }
      }
    }
    const missing = failed.map((i) => `${i.t}${i.v ? ` (${i.v})` : ''}`).join(', ');
    const added = failed.length < items.length;
    if (!added) return { added, missing };

    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source });
    window.kmDust && window.kmDust();
    try {
      if (!drawer) throw new Error('no drawer');
      if (!response) {
        const url = `${window.location.pathname}?sections=${sections.join(',')}`;
        response = { sections: await fetch(url, { credentials: 'same-origin' }).then((r) => r.json()) };
      }
      drawer.renderContents(response);
    } catch (e) {
      window.location.href = window.routes?.cart_url || '/cart';
      return { added, missing };
    }
    if (missing) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = `Gerade nicht verfügbar: ${missing}`;
    }
    return { added, missing };
  };
  window.kmAddItems = kmAddItems;

  const fmtDate = (ts) => {
    const date = new Date(ts);
    const opts = { day: 'numeric', month: 'long' };
    if (date.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
    return date.toLocaleDateString('de-DE', opts);
  };

  class KmReorder extends HTMLElement {
    connectedCallback() {
      if (!this.kmBound) {
        this.kmBound = true;
        this.addEventListener('click', (event) => {
          const one = event.target.closest('[data-km-reorder-add]');
          if (one) return this.add(one, [this.items[Number(one.dataset.index)]]);
          const all = event.target.closest('[data-km-reorder-all]');
          if (all) return this.add(all, this.items);
          if (event.target.closest('[data-km-reorder-dismiss]')) this.dismiss();
        });
      }
      this.render();
    }

    // Neuere Quelle gewinnt: im Browser gemerkter Einkauf oder letzte Bestellung im Kundenkonto
    source() {
      let order = null;
      const el = this.querySelector('[data-km-reorder-order]');
      if (el) {
        try {
          order = JSON.parse(el.textContent);
        } catch (e) {}
      }
      return (
        [store.get(REORDER_KEYS.last), order]
          .filter((s) => s && reorderItems(s.items).length)
          .sort((a, b) => (b.ts || 0) - (a.ts || 0))[0] || null
      );
    }

    render() {
      const designMode = this.hasAttribute('data-design-mode');
      const data = this.dataset.cartEmpty === 'true' ? this.source() : null;
      const dismissed = data && store.get(REORDER_KEYS.hidden) === data.ts;
      this.items = data && !dismissed ? reorderItems(data.items) : [];
      this.hidden = !this.items.length && !designMode;
      const shell = this.closest('.km-reorder-section');
      if (shell) shell.hidden = this.hidden;
      const preview = this.querySelector('[data-km-reorder-preview]');
      if (preview) preview.hidden = this.items.length > 0;
      if (!this.items.length) return;

      this.querySelector('[data-km-reorder-sub]').textContent = `Ihr Einkauf vom ${fmtDate(data.ts)}`;
      const list = this.querySelector('[data-km-reorder-list]');
      list.replaceChildren();
      const visible = this.dataset.context === 'home' ? 8 : 4;
      this.items.slice(0, visible).forEach((item, index) => {
        const li = document.createElement('li');
        li.className = 'km-reorder__item';
        const media = document.createElement('a');
        media.className = 'km-reorder__media';
        media.href = item.url || '#';
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');
        if (item.img) {
          const img = document.createElement('img');
          img.src = item.img;
          img.alt = '';
          img.width = 60;
          img.height = 60;
          img.loading = 'lazy';
          media.append(img);
        }
        const info = document.createElement('div');
        info.className = 'km-reorder__info';
        const name = document.createElement('a');
        name.className = 'km-reorder__name';
        name.href = item.url || '#';
        name.textContent = item.t || 'Artikel';
        const meta = document.createElement('span');
        meta.className = 'km-reorder__meta';
        meta.textContent = item.v ? `${item.q} × ${item.v}` : `${item.q} Stück`;
        info.append(name, meta);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'km-reorder__add';
        button.dataset.kmReorderAdd = '';
        button.dataset.index = String(index);
        button.setAttribute('aria-label', `${item.q} × ${item.t}${item.v ? ` ${item.v}` : ''} in den Warenkorb legen`);
        button.textContent = '+ In den Warenkorb';
        li.append(media, info, button);
        list.append(li);
      });
      if (this.items.length > visible) {
        const more = document.createElement('li');
        more.className = 'km-reorder__rest';
        const rest = this.items.length - visible;
        more.textContent = `+ ${rest} weitere${rest === 1 ? 'r Artikel' : ' Artikel'} – mit „Alles in den Warenkorb“ dabei`;
        list.append(more);
      }
      const all = this.querySelector('[data-km-reorder-all]');
      all.hidden = this.items.length < 2;
    }

    dismiss() {
      const data = this.source();
      if (data) store.set(REORDER_KEYS.hidden, data.ts);
      document.querySelectorAll('km-reorder').forEach((el) => el.render());
    }

    async add(button, items) {
      items = items.filter(Boolean);
      if (!items.length || button.getAttribute('aria-disabled') === 'true') return;
      const status = this.querySelector('[data-km-reorder-status]');
      const label = button.textContent;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      status.textContent = '';

      const result = await kmAddItems(items, { source: 'km-reorder', drawer: this.dataset.context !== 'cart' });
      // Auf der Startseite bleibt der Block stehen: angeklickte Artikel als erledigt markieren
      if (!this.isConnected) return;
      button.classList.remove('loading');
      if (result.added) {
        button.textContent = button.hasAttribute('data-km-reorder-all') ? '✓ Alles im Warenkorb' : '✓ Im Warenkorb';
      } else {
        button.removeAttribute('aria-disabled');
        button.textContent = label;
      }
      if (result.missing) status.textContent = `Gerade nicht verfügbar: ${result.missing}`;
    }
  }
  if (!customElements.get('km-reorder')) customElements.define('km-reorder', KmReorder);

  const DAY_KEYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  const DAY_NAMES = { So: 'Sonntag', Mo: 'Montag', Di: 'Dienstag', Mi: 'Mittwoch', Do: 'Donnerstag', Fr: 'Freitag', Sa: 'Samstag' };

  class KmOpenStatus extends HTMLElement {
    connectedCallback() {
      if (!DATA || !DATA.store) return;
      this.render();
    }

    berlinNow() {
      const parts = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(new Date());
      const get = (type) => parts.find((p) => p.type === type)?.value;
      return {
        day: (get('weekday') || '').replace('.', '').slice(0, 2),
        date: `${get('year')}-${get('month')}-${get('day')}`,
        minutes: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10),
      };
    }

    render() {
      const store = DATA.store;
      const days = (store.days || '').split(',').map((d) => d.trim()).filter(Boolean);
      const slots = (store.hours || [])
        .filter(Boolean)
        .map((range) => range.split('-').map((t) => {
          const [h, m] = t.trim().split(':').map(Number);
          return h * 60 + (m || 0);
        }))
        .filter((s) => s.length === 2 && !s.some(Number.isNaN));
      const now = this.berlinNow();
      const closed = store.closedFrom && store.closedTo && now.date >= store.closedFrom && now.date <= store.closedTo;
      const fmt = (min) => `${Math.floor(min / 60)}${min % 60 ? ':' + String(min % 60).padStart(2, '0') : ''} Uhr`;
      let text;
      let open = false;
      if (closed) {
        const [y, m, d] = store.closedTo.split('-');
        text = `Betriebsurlaub bis ${d}.${m}.${y}`;
      } else if (days.includes(now.day)) {
        const current = slots.find(([from, to]) => now.minutes >= from && now.minutes < to);
        const later = slots.find(([from]) => now.minutes < from);
        if (current) {
          open = true;
          text = `Heute geöffnet bis ${fmt(current[1])}`;
        } else if (later) {
          text = `Heute ab ${fmt(later[0])} geöffnet`;
        }
      }
      if (!text) {
        const today = DAY_KEYS.indexOf(now.day);
        for (let i = 1; i <= 7; i++) {
          const key = DAY_KEYS[(today + i) % 7];
          if (days.includes(key) && slots.length) {
            text = `${i === 1 ? 'Morgen' : DAY_NAMES[key]} ab ${fmt(slots[0][0])} wieder da`;
            break;
          }
        }
      }
      if (!text) return;
      this.classList.toggle('is-open', open);
      this.innerHTML = `<span class="km-open__dot" aria-hidden="true"></span><span>${text}</span>`;
    }
  }
  if (!customElements.get('km-open-status')) customElements.define('km-open-status', KmOpenStatus);

  /* Suche: Vorschläge-Chips übernehmen den Begriff, Vorschläge verschwinden beim Tippen */
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-km-search-term]');
    if (!chip) return;
    const scope = chip.closest('.search-modal__content');
    const input = scope && scope.querySelector('input[type="search"]');
    if (!input) return;
    event.preventDefault();
    input.value = chip.dataset.kmSearchTerm;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
    scope.classList.add('km-has-query');
  });
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.search-modal input[type="search"]')) return;
    const scope = input.closest('.search-modal__content');
    if (scope) scope.classList.toggle('km-has-query', input.value.trim().length > 0);
  });
  document.addEventListener('reset', (event) => {
    const scope = event.target.closest && event.target.closest('.search-modal__content');
    if (scope) scope.classList.remove('km-has-query');
  }, true);

  /* Produktgalerie mobil: Punkte zeigen das aktive Bild */
  const setupGalleryDots = () => {
    document.querySelectorAll('slider-component[id^="GalleryViewer"]').forEach((viewer) => {
      if (viewer.dataset.kmDots) return;
      const list = viewer.querySelector('.product__media-list');
      if (!list) return;
      const slides = Array.from(list.children).filter((li) => !li.hidden && getComputedStyle(li).display !== 'none');
      if (slides.length < 2) return;
      viewer.dataset.kmDots = 'true';
      const dots = document.createElement('div');
      dots.className = 'km-dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Produktbilder');
      slides.forEach((slide, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Bild ${i + 1} von ${slides.length}`);
        b.addEventListener('click', () => list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: 'smooth' }));
        dots.appendChild(b);
      });
      list.after(dots);
      const update = () => {
        const index = Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
        dots.querySelectorAll('button').forEach((b, i) => b.setAttribute('aria-current', i === index ? 'true' : 'false'));
      };
      list.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      update();
    });
  };
  document.addEventListener('DOMContentLoaded', setupGalleryDots);
  document.addEventListener('shopify:section:load', setupGalleryDots);

  /* Kollektionstexte kürzen, ausklappbar. data-km-clamp="2" = zwei Zeilen auf allen Breiten,
     leeres Attribut = drei Zeilen nur auf dem Handy.
     Gemessen wird nur sichtbarer Inhalt (Text, Bilder, Tabellen): In Produkttexten stecken oft leere,
     aus alten Shops kopierte Blöcke, und Zutaten/Nährwerte wandern erst später ins Akkordeon.
     Sonst erschien „Mehr lesen“ unter zwei kurzen Zeilen. */
  const clampMedia = 'img, video, iframe, table, svg, hr';
  const clampContentHeight = (el) => {
    const top = el.getBoundingClientRect().top;
    let bottom = 0;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    while (walker.nextNode()) {
      if (!walker.currentNode.textContent.trim()) continue;
      range.selectNodeContents(walker.currentNode);
      const r = range.getBoundingClientRect();
      if (r.height) bottom = Math.max(bottom, r.bottom - top);
    }
    el.querySelectorAll(clampMedia).forEach((m) => {
      const r = m.getBoundingClientRect();
      if (r.height) bottom = Math.max(bottom, r.bottom - top);
    });
    return bottom;
  };
  /* Leere Blöcke am Ende der Produktbeschreibung ausblenden (nur Abstand, kein Inhalt) */
  const hideEmptyTail = (el) => {
    for (let c = el.lastElementChild; c; c = c.previousElementSibling) {
      const ownElement = c.tagName.includes('-') || /(^|\s)km-/.test(c.className);
      if (ownElement || c.textContent.trim() || c.matches(clampMedia) || c.querySelector(clampMedia)) {
        if (getComputedStyle(c).display !== 'none') break;
        continue;
      }
      c.style.display = 'none';
    }
  };
  const unclamp = (el) => {
    el.classList.remove('km-clamp', 'is-open');
    el.style.removeProperty('--km-clamp-h');
    const btn = el.nextElementSibling;
    if (btn && btn.classList.contains('km-clamp__toggle')) btn.remove();
  };
  const recheckClamp = () => {
    document.querySelectorAll('.km-clamp[data-km-clamp-limit]').forEach((el) => {
      if (el.classList.contains('km-desc')) hideEmptyTail(el);
      if (clampContentHeight(el) <= parseFloat(el.dataset.kmClampLimit) + 4) unclamp(el);
    });
  };
  const setupClamp = () => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('[data-km-clamp]:not([data-km-clamp-ready])').forEach((el) => {
      const lines = parseInt(el.dataset.kmClamp, 10);
      if (!lines && !mobile) return;
      el.dataset.kmClampReady = 'true';
      const firstText = el.querySelector('p, li') || el;
      const lh = parseFloat(getComputedStyle(firstText).lineHeight) || 24;
      const limit = Math.round(lh * (lines || 3));
      if (el.classList.contains('km-desc')) hideEmptyTail(el);
      if (el.scrollHeight <= limit + 4 || clampContentHeight(el) <= limit + 4) return;
      el.dataset.kmClampLimit = String(limit);
      el.style.setProperty('--km-clamp-h', `${limit}px`);
      el.classList.add('km-clamp');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'km-clamp__toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Mehr lesen';
      btn.addEventListener('click', () => {
        const open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
      });
      el.after(btn);
    });
  };
  document.addEventListener('DOMContentLoaded', setupClamp);
  /* Nach dem Umsortieren (Akkordeons, Spalten) noch einmal prüfen */
  window.addEventListener('load', recheckClamp);

  /* Mehlstaub am Warenkorb-Symbol nach dem Hinzufügen */
  window.kmDust = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('km-dust');
    void icon.offsetWidth;
    icon.classList.add('km-dust');
    setTimeout(() => icon.classList.remove('km-dust'), 900);
  };
  // Mobile Navigation: „Hier bin ich“. Öffnet beim Aufklappen den Bereich der aktuellen Seite.
  // Produktseiten nutzen eine Kollektion, zu der das Produkt gehört (bevorzugt die zuletzt
  // besuchte). Seiten ohne Menüeintrag (Startseite, Suche, Warenkorb …) zeigen die Hauptebene.
  // Startseite: freistehende Kopfzeile – Höhe messen, damit das Hero-Bild darunter beginnt
  // Mobile Navigation im Vollbild: Schließen-Knopf in der eigenen Kopfleiste des Menüs
  const setupDrawerClose = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-km-drawer-close]');
      if (!btn) return;
      const summary = btn.closest('details')?.querySelector(':scope > summary');
      if (summary) summary.click();
    });
  };

  // Schnellansicht und Bild-Großansicht: Escape schließt immer, auch wenn der Fokus nicht im Dialog liegt
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('quick-add-modal[open], product-modal[open]');
    if (open && typeof open.hide === 'function') open.hide();
  });

  const setupFloatHeader = () => {
    const section = document.querySelector('.section-header');
    if (!section || !section.querySelector(':scope > .km-float')) return;
    const set = () => document.documentElement.style.setProperty('--km-float-h', section.offsetHeight + 'px');
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(section);
  };

  const setupNavMemory = () => {
    const drawer = document.querySelector('#menu-drawer');
    const container = document.querySelector('header-drawer details#Details-menu-drawer-container');
    if (!drawer || !container) return;
    const ctx = drawer.querySelector('[data-km-nav-context]');
    const template = ctx ? ctx.dataset.kmNavContext : '';
    const store = {
      get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} }
    };
    const path = (href) => { try { return new URL(href, location.origin).pathname.replace(/\/$/, '') || '/'; } catch (e) { return href; } };
    const topDetails = (el) => el.closest('.menu-drawer__menu > li > details');
    const menuLinks = () => [...drawer.querySelectorAll('.menu-drawer__menu a[href]')];
    // Zuletzt besuchte Kollektion und zuletzt geöffneter Hauptbereich (nur zur Auswahl bei Doppelungen)
    if (template === 'collection') store.set('km-nav-coll', path(location.pathname));
    drawer.addEventListener('click', (e) => {
      const a = e.target.closest('.menu-drawer__menu a[href]');
      const d = a && topDetails(a);
      if (d) store.set('km-nav-top', d.id);
    });
    const pick = (links) => {
      if (!links.length) return null;
      const preferred = store.get('km-nav-top');
      return links.find((a) => topDetails(a) && topDetails(a).id === preferred)
        || links.find((a) => topDetails(a))
        || links[0];
    };
    const target = () => {
      const current = [...drawer.querySelectorAll('.menu-drawer__menu a[aria-current="page"]')];
      if (current.length) return pick(current);
      if (template === 'product' && ctx) {
        const colls = (ctx.dataset.kmProductCollections || '').split(',').filter(Boolean).map(path);
        const last = store.get('km-nav-coll');
        const order = last && colls.includes(last) ? [last].concat(colls.filter((c) => c !== last)) : colls;
        for (const c of order) {
          const hit = pick(menuLinks().filter((a) => path(a.getAttribute('href')) === c));
          if (hit) return hit;
        }
      }
      return null;
    };
    let applied = false;
    const apply = () => {
      drawer.querySelectorAll('.km-nav-here, .km-nav-here-top').forEach((el) => el.classList.remove('km-nav-here', 'km-nav-here-top'));
      const link = target();
      if (!link) return;
      link.classList.add('km-nav-here');
      const details = topDetails(link);
      if (details) details.querySelector(':scope > summary')?.classList.add('km-nav-here-top');
      if (!details) return;
      // Untermenü(s) ohne Einschieben öffnen: Zustand direkt setzen wie MenuDrawer (assets/global.js),
      // Übergänge nur für diesen Moment aus. Die Schublade gleitet mit dem offenen Untermenü herein.
      const chain = [];
      for (let d = link.closest('details'); d && d !== container; d = d.parentElement.closest('details')) chain.unshift(d);
      drawer.classList.add('km-nav-instant');
      chain.forEach((d) => {
        d.setAttribute('open', '');
        d.classList.add('menu-opening');
        d.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
        d.parentElement.closest('.has-submenu')?.classList.add('submenu-open');
      });
      // Aktuellen Unterpunkt in die Mitte des Untermenüs rollen
      const panel = link.closest('.menu-drawer__submenu');
      if (panel) {
        const off = link.getBoundingClientRect().top - panel.getBoundingClientRect().top;
        panel.scrollTop = Math.max(0, off - panel.clientHeight / 2 + link.offsetHeight / 2);
      }
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.remove('km-nav-instant')));
    };
    new MutationObserver(() => {
      if (container.hasAttribute('open')) {
        if (!applied) { applied = true; apply(); }
      } else {
        applied = false;
      }
    }).observe(container, { attributes: true, attributeFilter: ['open'] });
  };

  /* Produktseite: Nährwerte/Zutaten/Allergiehinweis stehen im Aufklapper (snippets/km-naehrwerte.liquid).
     Dieselben Abschnitte in der Beschreibung ausblenden – nur die, für die es Metafeld-Daten gibt. */
  const setupNutriDedupe = () => {
    const box = document.querySelector('[data-km-nutri][data-hide-desc]');
    const desc = document.querySelector('.product-description');
    if (!box || !desc) return;
    const has = box.dataset.hideDesc || '';
    const kindOf = (t) => {
      if (/^zutaten/i.test(t)) return 'z';
      if (/^allergi/i.test(t)) return 'a';
      if (/nährwert|enthalten durchschnittlich|^durchschnittliche/i.test(t)) return 'n';
      return null;
    };
    const isHeading = (el) =>
      /^H[1-6]$/.test(el.tagName) ||
      (el.tagName === 'P' && el.textContent.trim() && [...el.childNodes].every((n) =>
        (n.nodeType === 3 && !n.textContent.trim()) || (n.nodeType === 1 && /^(STRONG|B)$/.test(n.tagName))));
    const isNutriTable = (el) =>
      (el.matches('table, .naehrwerttabelle, .leftblock') || el.querySelector('.naehrwerttabelle')) &&
      /energie|brennwert|kohlenhydrat|eiwei/i.test(el.textContent);
    let state = null;
    [...desc.children].forEach((el) => {
      const t = el.textContent.replace(/\s+/g, ' ').trim();
      if (isNutriTable(el)) {
        if (has.includes('n')) el.hidden = true;
        state = null;
        return;
      }
      if (isHeading(el)) {
        const k = kindOf(t);
        state = k && has.includes(k) ? k : null;
        if (state) el.hidden = true;
        return;
      }
      const inline = kindOf(t);
      if (inline && /^(zutaten|allergiehinweis)\s*:/i.test(t) && has.includes(inline)) {
        el.hidden = true;
        return;
      }
      if (state && !/^inhalt\b/i.test(t)) el.hidden = true;
      else state = null;
    });
  };
  document.addEventListener('DOMContentLoaded', setupNutriDedupe);

  /* Teilen-Leiste (snippets/km-share.liquid): Link kopieren, Teilen-Menü des Geräts */
  const setupShare = () => {
    document.querySelectorAll('[data-km-share]:not([data-km-share-ready])').forEach((box) => {
      box.dataset.kmShareReady = 'true';
      const status = box.querySelector('.km-share__status');
      const say = (msg) => {
        if (!status) return;
        status.textContent = msg;
        clearTimeout(box.kmShareTimer);
        box.kmShareTimer = setTimeout(() => (status.textContent = ''), 2500);
      };
      const copy = box.querySelector('[data-km-share-copy]');
      if (copy) {
        copy.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(box.dataset.url);
            say('Link kopiert');
          } catch (e) {
            window.prompt('Link kopieren:', box.dataset.url);
          }
        });
      }
      const nativeWrap = box.querySelector('[data-km-share-native-wrap]');
      if (nativeWrap && navigator.share) {
        nativeWrap.hidden = false;
        nativeWrap.querySelector('button').addEventListener('click', () => {
          navigator.share({ title: box.dataset.title, url: box.dataset.url }).catch(() => {});
        });
      }
    });
  };
  document.addEventListener('DOMContentLoaded', setupShare);
  document.addEventListener('shopify:section:load', setupShare);

  /* Produktseite: Links zum Mühlenladen öffnen ein Overlay (snippets/km-store-dialog.liquid) */
  const setupStoreDialog = () => {
    const dlg = document.querySelector('[data-km-store-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.dataset.kmReady) return;
    dlg.dataset.kmReady = 'true';
    const page = (dlg.dataset.page || '/pages/muhlenladen').replace(/\/$/, '');
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || a.hasAttribute('data-km-store-page')) return;
      if (!a.closest('.shopify-section[id$="__main"], pickup-availability-drawer')) return;
      let path;
      try { path = new URL(a.href, location.origin).pathname.replace(/\/$/, ''); } catch (err) { return; }
      if (path !== page) return;
      e.preventDefault();
      const drawer = a.closest('pickup-availability-drawer');
      if (drawer && typeof drawer.hide === 'function') drawer.hide();
      dlg.showModal();
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-km-store-close]')) dlg.close();
    });
  };
  document.addEventListener('DOMContentLoaded', setupStoreDialog);

  /* Overlays statt Seitenwechsel beim Einkaufen (Warenkorb-Drawer, Warenkorb- und Produktseite):
     - Links zur Kontaktseite und Elemente mit data-km-contact-open → Kontaktformular (snippets/km-contact-dialog.liquid),
       Betreff/Bezug/Titel/Text aus data-topic, data-ref, data-title, data-lead, data-placeholder
     - Links auf /pages/… und /policies/… sowie data-km-page-overlay → Seiten-Overlay (snippets/km-page-dialog.liquid);
       übernommen wird nur der Inhalt ab der H1 (Überschriften, Absätze, Listen, Tabellen)
     Links zum Mühlenladen öffnet weiter das Laden-Overlay (setupStoreDialog). */
  const OVERLAY_SCOPE = 'cart-drawer, .shopify-section[id$="__main"], .shopify-section[id*="__cart"], .km-store-dialog, pickup-availability-drawer';
  const pathOf = (href) => {
    try { return new URL(href, location.origin).pathname.replace(/\/$/, ''); } catch (err) { return ''; }
  };
  // Drawer (Warenkorb, Merkliste) halten den Fokus fest (trapFocus aus global.js) – solange ein Overlay offen ist,
  // loslassen, sonst lässt sich im Formular nicht tippen; danach wieder an den offenen Drawer geben.
  const openOverlay = (dlg) => {
    document.querySelectorAll('dialog[open]').forEach((d) => d !== dlg && d.close());
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    dlg.showModal();
  };
  const restoreDrawerFocus = () => {
    const drawer = document.querySelector('cart-drawer.active .drawer-inner, km-wishlist-drawer.active .drawer-inner');
    if (drawer && typeof trapFocus === 'function') trapFocus(drawer);
  };

  const setupContactDialog = () => {
    const dlg = document.querySelector('[data-km-contact-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.dataset.kmReady) return;
    dlg.dataset.kmReady = 'true';
    const q = (sel) => dlg.querySelector(sel);
    const defaults = {
      title: q('[data-km-contact-title]')?.textContent || '',
      lead: q('[data-km-contact-lead]')?.textContent || '',
    };
    const open = (src = {}) => {
      const set = (sel, prop, value) => { const el = q(sel); if (el) el[prop] = value; };
      set('[data-km-contact-title]', 'textContent', src.title || defaults.title);
      set('[data-km-contact-lead]', 'textContent', src.lead || defaults.lead);
      set('[data-km-contact-topic]', 'value', src.topic || 'Allgemeine Anfrage');
      set('[data-km-contact-ref]', 'value', src.ref || location.href);
      set('[data-km-contact-body]', 'placeholder', src.placeholder || '');
      openOverlay(dlg);
    };
    window.kmOpenContact = open;
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-km-contact-open]');
      const link = !trigger && e.target.closest('a[href]');
      if (link && (link.target === '_blank' || !link.closest(OVERLAY_SCOPE) || pathOf(link.href) !== '/pages/contact')) return;
      if (!trigger && !link) return;
      e.preventDefault();
      open((trigger || link).dataset);
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-km-contact-close]')) dlg.close();
    });
    dlg.addEventListener('close', restoreDrawerFocus);
    if (dlg.dataset.state) dlg.showModal();
  };
  document.addEventListener('DOMContentLoaded', setupContactDialog);

  const setupPageDialog = () => {
    const dlg = document.querySelector('[data-km-page-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.dataset.kmReady) return;
    dlg.dataset.kmReady = 'true';
    const title = dlg.querySelector('[data-km-page-title]');
    const body = dlg.querySelector('[data-km-page-body]');
    const more = dlg.querySelector('[data-km-page-link]');
    const storePage = (document.querySelector('[data-km-store-dialog]')?.dataset.page || '').replace(/\/$/, '');
    const cache = new Map();
    const extract = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const main = doc.querySelector('#MainContent') || doc.querySelector('main') || doc.body;
      main.querySelectorAll('script, style, noscript, nav, form, button, .breadcrumbs, [hidden]').forEach((n) => n.remove());
      const h1 = main.querySelector('h1');
      const picked = [];
      main.querySelectorAll('h2, h3, h4, p, ul, ol, table').forEach((el) => {
        if (h1 && !(h1.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
        if (picked.some((p) => p.contains(el))) return;
        const text = el.textContent.trim();
        if (!text) return;
        // Überschrift, die nur den Titel wiederholt (z. B. „Versand“ in der Versandrichtlinie), weglassen
        if (/^H[2-4]$/.test(el.tagName) && h1 && text.toLowerCase() === h1.textContent.trim().toLowerCase()) return;
        picked.push(el);
      });
      return { heading: h1 ? h1.textContent.trim() : '', html: picked.map((el) => el.outerHTML).join('') };
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      // Gewährleistung hat ein eigenes Overlay (snippets/km-gewaehrleistung.liquid)
      if (!a || a.target === '_blank' || e.defaultPrevented || a.hasAttribute('data-gewaehrleistung')) return;
      const path = pathOf(a.href);
      const wanted = a.hasAttribute('data-km-page-overlay')
        || (a.closest(OVERLAY_SCOPE) && !a.closest('[data-km-page-dialog]')
          && (/^\/policies\//.test(path) || /^\/pages\//.test(path))
          && path !== '/pages/contact' && path !== storePage);
      if (!wanted || new URL(a.href, location.origin).origin !== location.origin) return;
      e.preventDefault();
      const url = a.href;
      more.href = url;
      title.textContent = a.textContent.trim();
      body.innerHTML = '<p>Wird geladen …</p>';
      openOverlay(dlg);
      const job = cache.get(url) || fetch(url).then((r) => (r.ok ? r.text() : Promise.reject())).then(extract);
      cache.set(url, job);
      job
        .then((res) => {
          if (res.heading) title.textContent = res.heading;
          body.innerHTML = res.html || '<p>Kein Inhalt gefunden.</p>';
        })
        .catch(() => {
          cache.delete(url);
          body.innerHTML = `<p>Die Seite konnte gerade nicht geladen werden. <a href="${url}">Seite öffnen</a></p>`;
        });
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-km-page-close]')) dlg.close();
    });
    dlg.addEventListener('close', restoreDrawerFocus);
  };
  document.addEventListener('DOMContentLoaded', setupPageDialog);

  // Kollektionen: automatisch nachladen (nur das Produktraster per Section Rendering API)
  class KmLoadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.km-more__button');
      this.loading = false;
      if (this.button) {
        this.button.addEventListener('click', (e) => { e.preventDefault(); this.load(); });
      }
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) this.load();
        }, { rootMargin: '900px 0px' });
        this.io.observe(this);
      }
    }
    disconnectedCallback() {
      this.io && this.io.disconnect();
    }
    async load() {
      const next = this.dataset.next;
      const grid = document.getElementById('product-grid');
      if (this.loading || !next || !grid) return;
      this.loading = true;
      this.classList.add('is-loading');
      try {
        const url = new URL(next, location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        const res = await fetch(url.toString());
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const items = doc.querySelectorAll('#product-grid > li');
        const frag = document.createDocumentFragment();
        items.forEach((li) => frag.appendChild(document.adoptNode(li)));
        grid.appendChild(frag);
        const nextMore = doc.querySelector('km-load-more');
        const shown = grid.querySelectorAll(':scope > li').length;
        const total = parseInt(this.dataset.total, 10) || shown;
        if (nextMore && nextMore.dataset.next) {
          this.dataset.next = nextMore.dataset.next;
          this.button && this.button.setAttribute('href', nextMore.dataset.next);
          const s = this.querySelector('[data-km-more-shown]');
          if (s) s.textContent = shown;
          const bar = this.querySelector('.km-more__bar span');
          if (bar) bar.style.width = Math.round((shown / total) * 100) + '%';
          this.loading = false;
          this.classList.remove('is-loading');
          // Ist das Ende noch in Sicht, gleich weiterladen
          this.io && (this.io.unobserve(this), this.io.observe(this));
        } else {
          this.remove();
        }
      } catch (e) {
        this.loading = false;
        this.classList.remove('is-loading');
        this.classList.add('has-error');
      }
    }
  }
  if (!customElements.get('km-load-more')) customElements.define('km-load-more', KmLoadMore);

  // Großansicht der Produktbilder: waagerechte Galerie mit Pfeilen, Zähler und Tastatur
  const setupLightbox = (modal) => {
    if (modal.dataset.kmLb) return;
    modal.dataset.kmLb = '1';
    const track = modal.querySelector('.product-media-modal__content');
    const dialog = modal.querySelector('.product-media-modal__dialog');
    if (!track || !dialog) return;
    const arrow = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
    const prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'km-lb__nav km-lb__nav--prev'; prev.setAttribute('aria-label', 'Vorheriges Bild');
    prev.innerHTML = arrow('M15 18l-6-6 6-6');
    const next = document.createElement('button');
    next.type = 'button'; next.className = 'km-lb__nav km-lb__nav--next'; next.setAttribute('aria-label', 'Nächstes Bild');
    next.innerHTML = arrow('M9 6l6 6-6 6');
    const count = document.createElement('p');
    count.className = 'km-lb__count'; count.setAttribute('aria-live', 'polite');
    dialog.append(prev, next, count);
    const slides = () => [...track.children].filter((el) => el.offsetParent !== null || el.getClientRects().length);
    const index = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const update = () => {
      const n = slides().length, i = Math.min(index(), n - 1);
      count.textContent = n > 1 ? `${i + 1} / ${n}` : '';
      count.hidden = n < 2;
      prev.disabled = i <= 0;
      next.disabled = i >= n - 1;
    };
    const go = (step) => track.scrollTo({ left: (index() + step) * track.clientWidth, behavior: 'smooth' });
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    // Flux schließt die Großansicht bei jedem Maus-pointerup außerhalb von Videos (global.js, ModalDialog) –
    // ohne das hier schloss ein Klick auf den Pfeil das Fenster, statt weiterzublättern
    [prev, next, count].forEach((el) => el.addEventListener('pointerup', (e) => e.stopPropagation()));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    // Beim Öffnen auf das angetippte Bild springen (ohne Animation)
    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) return;
      requestAnimationFrame(() => {
        const active = track.querySelector(':scope > .active');
        const i = active ? slides().indexOf(active) : 0;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = Math.max(i, 0) * track.clientWidth;
        track.style.scrollBehavior = '';
        update();
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    update();
  };
  const initLightboxes = () => document.querySelectorAll('product-modal.product-media-modal').forEach(setupLightbox);

  document.addEventListener('DOMContentLoaded', () => {
    const field = document.querySelector('[data-km-field]');
    initLightboxes();
    document.addEventListener('click', (e) => {
      if (e.target.closest('modal-opener, .product__modal-opener')) initLightboxes();
    }, true);
    setupNavMemory();
    setupFloatHeader();
    setupDrawerClose();
    if (field) {
      // Ährenfeld (assets/km-aehrenfeld.svg) erst kurz vor dem Sichtbereich laden und inline einsetzen
      let loading = null;
      const mount = () => {
        if (!loading) {
          loading = fetch(field.dataset.src)
            .then((r) => (r.ok ? r.text() : ''))
            .then((svg) => { if (svg.startsWith('<svg')) field.innerHTML = svg; })
            .catch(() => {});
        }
        return loading;
      };
      if ('IntersectionObserver' in window) {
        const near = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            mount();
            near.disconnect();
          }
        }, { rootMargin: '600px 0px' });
        near.observe(field);
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            mount().then(() => requestAnimationFrame(() => field.classList.add('is-visible')));
          }
        }, { threshold: 0.3 });
        io.observe(field);
      } else {
        mount();
      }
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'product-form') window.kmDust();
      });
    }
  });
})();
